module.exports = __webpack_public_path__ + "static/media/Poudre.d945e378.jpg";